import { createRoot } from 'react-dom/client'
import { Toast, ToastContainer, ThemeProvider } from '@mdsol/onex-design'
import React from 'react'

let toastId = 0

const showToast = (variant: 'success' | 'critical' | 'caution' | 'information', header: string) => {
  const id = toastId++

  // Create a dedicated container for this toast
  const toastWrapper = document.createElement('div')
  toastWrapper.style.position = 'fixed'
  toastWrapper.style.top = '20px'
  toastWrapper.style.right = '20px'
  toastWrapper.style.zIndex = '9999'
  document.body.appendChild(toastWrapper)

  const root = createRoot(toastWrapper)

  const handleClose = () => {
    setTimeout(() => {
      root.unmount()
      toastWrapper.remove()
    }, 300)
  }

  root.render(
    <ThemeProvider>
      <ToastContainer position="top-right">
        <Toast variant={variant} header={header} show={true} autohide={true} delay={4000} onClose={handleClose} />
      </ToastContainer>
    </ThemeProvider>
  )
}

export const toast = {
  success: (message: string) => showToast('success', message),
  error: (message: string) => showToast('critical', message),
  warning: (message: string) => showToast('caution', message),
  info: (message: string) => showToast('information', message)
}
